module.exports = __webpack_public_path__ + "static/media/back.bf30108f.svg";